import styled from 'styled-components';
import { Icon } from '../../../icon';
import { getColorShade } from '../../../../../src/styled/utils';
export const SortIconContainer = styled.span `
  display: flex;
  align-items: center;
  width: 1em;
  height: 1em;
`;
export const SortIcon = styled(Icon).attrs({
    name: 'sort',
    viewBox: '-5 0 20 20'
}) `
  path:first-child {
    fill: ${({ $isSortedDesc }) => getColorShade('onSurface', $isSortedDesc ? 'highEmphasis' : 'lowEmphasis')};
  }

  path:last-child {
    fill: ${({ $isSortedAsc }) => getColorShade('onSurface', $isSortedAsc ? 'highEmphasis' : 'lowEmphasis')};
  }
`;
